import React from 'react';
import { motion } from 'framer-motion';
const pains = ['Trabajás mucho, pero no ves la plata clara a fin de mes porque tus costos están desordenados.', 'WhatsApp te consume tiempo y respondés consultas que nunca terminan en una reserva real.', 'Te cuesta poner precios con seguridad y sentís que estás trabajando de más para ganar menos.', 'Todo depende de tu cabeza y tu esfuerzo diario, sin un sistema claro ni políticas que te protejan de cancelaciones.'];
export function PainPoints() {
  return <section className="py-20 bg-white" data-id="element-209">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <h2 className="text-2xl md:text-3xl font-bold mb-10 text-center text-gray-900" data-id="element-211">
          Si sos manicurista, esto te va a sonar familiar:
        </h2>

        <div className="space-y-4 mb-12" data-id="element-212">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-5 bg-red-50/50 rounded-2xl border border-red-100" data-id="element-213">
              <span className="text-xl shrink-0 mt-0.5" aria-hidden="true" data-id="element-214">
                ❌
              </span>
              <p className="text-gray-800 font-medium text-lg leading-relaxed" data-id="element-215">
                {pain}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-216">
          <h3 className="text-xl md:text-2xl font-bold text-ocean-teal-dark mb-4" data-id="element-217">
            ¿Cuántos meses más vas a seguir improvisando tu negocio?
          </h3>
          <p className="text-gray-600 text-lg leading-relaxed" data-id="element-218">
            Da igual si atendés en Santiago, en Viña del Mar, en Concepción o en
            cualquier ciudad de LatAm. El problema es exactamente el mismo. Y la
            solución también.
          </p>
        </div>
      </div>
    </section>;
}